import React from 'react';
import Icon from 'components/AppIcon';
import { KPI_CARDS } from './esgData';

export default function KPICards() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {KPI_CARDS?.map((kpi) => {
        const isGood = kpi?.good;
        const trendColor = isGood ? '#16a34a' : '#dc2626';
        const trendIcon = kpi?.trend === 'up' ? 'TrendingUp' : 'TrendingDown';
        return (
          <div key={kpi?.id} className="card card-interactive flex flex-col gap-3" style={{ padding: '16px 20px' }}>
            <div className="flex items-center justify-between">
              <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: 'var(--color-muted)' }}>
                <Icon name={kpi?.icon} size={18} color="var(--color-primary)" />
              </div>
              <div className="flex items-center gap-1" style={{ color: trendColor }}>
                <Icon name={trendIcon} size={14} color={trendColor} />
                <span className="font-caption text-xs font-semibold">{kpi?.change}</span>
              </div>
            </div>
            <div>
              <div className="font-heading font-bold text-foreground" style={{ fontSize: '1.375rem', lineHeight: 1.2 }}>
                {kpi?.value}
                {kpi?.unit && <span className="font-caption text-muted-foreground ml-1" style={{ fontSize: '0.75rem', fontWeight: 400 }}>{kpi?.unit}</span>}
              </div>
              <p className="font-caption text-muted-foreground mt-1" style={{ fontSize: '0.75rem', lineHeight: 1.4 }}>{kpi?.label}</p>
              {kpi?.lowerIsBetter && (
                <p className="font-caption mt-1" style={{ fontSize: '0.65rem', color: '#16a34a' }}>↓ Lower is better</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
